import React, { Component } from 'react';
import { computed, reaction } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import moment from 'moment';
import classnames from 'classnames';

import TopBar from 'components/TopBar';
import Button from 'material-ui/Button';

import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/CodeInfo';

import { SCROLL_ROOT_ID } from 'components/App';
import { DIRECTION_CUSTOMS } from 'stores/QueryParamsStore';
import BottomLine from './BottomLine';
import CodeInfoLicence from './codeinfo/CodeInfoLicence';
import CodeInfoQuota from './codeinfo/CodeInfoQuota';
import CodeInfoCertification from './codeinfo/CodeInfoCertification';
import CodeInfoDualUseGoods from './codeinfo/CodeInfoDualUseGoods';
import CodeInfoFeaturesOfCustomsClearance from './codeinfo/CodeInfoFeaturesOfCustomsClearance';
import CodeInfoFillingInstruction from './codeinfo/CodeInfoFillingInstruction';
import CodeInfoAdvice from './codeinfo/CodeInfoAdvice';
import CodeInfoClassificationCertificate from './codeinfo/CodeInfoClassificationCertificate';
import CodeInfoPreliminaryClassificationCertificate from './codeinfo/CodeInfoPreliminaryClassificationCertificate';
import CodeInfoNotes from './codeinfo/CodeInfoNotes';
import CodeInfoComments from './codeinfo/CodeInfoComments';
import CodeInfoClassificationComments from './codeinfo/CodeInfoClassificationComments';
import CodeInfoTree from './codeinfo/CodeInfoTree';
import CodeInfoTNVED14 from './codeinfo/CodeInfoTNVED14';
import CodeInfoImportDuty from './codeinfo/CodeInfoImportDuty';
import CodeInfoAdditionalUnit from './codeinfo/CodeInfoAdditionalUnit';
import CodeInfoFreeTradeZoneAgreements from './codeinfo/CodeInfoFreeTradeZoneAgreements';
import CodeInfoImportDutySNG from './codeinfo/CodeInfoImportDutySNG';
import CodeInfoTariffPreference from './codeinfo/CodeInfoTariffPreference';
import CodeInfoExportDuty from './codeinfo/CodeInfoExportDuty';
import CodeInfoAdditionalDues from './codeinfo/CodeInfoAdditionalDues';
import CodeInfoImportAkcis from './codeinfo/CodeInfoImportAkcis';
import CodeInfoExciseDutyMarks from './codeinfo/CodeInfoExciseDutyMarks';
import CodeInfoBudgetClassification from './codeinfo/CodeInfoBudgetClassification';
import CodeInfoImportVat from './codeinfo/CodeInfoImportVat';
import CodeInfoShortDescription from './codeinfo/CodeInfoShortDescription';
import CodeInfoDeadLine from './codeinfo/CodeInfoDeadLine';
import CodeInfoIntellectual from './codeinfo/CodeInfoIntellectual';
import CodeInfoParallelImport from './codeinfo/CodeInfoParallelImport';

import CodeInfoExportDutyAdjust from './codeinfo/CodeInfoExportDutyAdjust';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfo extends Component {

  constructor(params) {
    super(params)
    this.breakpoint = 700
    this.state = {
      isMobile: window.innerWidth <= this.breakpoint,
    }
  }

  @computed
  get model() {
    const { codes } = this.appStore.dataStore;
    if (codes.length) {
      return codes.items[0];
    }
  }

  @computed
  get descriptions() {
    const { description = [], shortDescription = '', code } = this.model;
    if (shortDescription) {
      description.push(`${code} ${shortDescription}`);
    }
    return description;
  }

  @computed
  get preliminaryClassificationCertificateSourceLink() {
    const { code, onDate } = this.appStore;
    const formattedCode = code ? `${code.slice(0, 4)} ${code.slice(4, 6)} ${code.slice(6, 9)} ${code.slice(9)}` : '';
    const query = JSON.stringify([{ c: "OWSCODETNVED", o: "phrase", v: formattedCode }]);
    const timestamp = onDate ? onDate.valueOf() : Date.now();

    return `https://portal.eaeunion.org/sites/odata/_layouts/15/Portal.EEC.Registry.Ui/DirectoryForm.aspx?ViewId=01d0337c-71f3-455b-950d-d882bf9547d9&ListId=0e3ead06-5475-466a-a340-6f69c01b5687&ItemId=219#onDate=${timestamp}&query=${encodeURIComponent(query)}`;
  }

  componentWillMount() {
    reaction(
      () => {
        const { code, direction, clearanceCountry, originCountry, dataStore } = this.appStore;
        return { code, clearanceCountry, originCountry, direction, dataStore };
      },
      ({ code, dataStore }) => {
        if (code)
          dataStore.fetchCodeData(code);
      },
      {
        compareStructural: true,
        fireImmediately: true
      }
    );
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResizeWindow.bind(this))
    this.handleResizeWindow()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResizeWindow)
  }

  handleResizeWindow = () => {
    this.setState({
      isMobile: window.innerWidth <= this.breakpoint,
    })
  }

  render() {
    if (!this.model) return '';

    const { classes } = this.props;
    const { code, code14, to_date, shortDescription } = this.model;
    const { showTitle, onDate, direction } = this.appStore;
    var duties = joinDuty(this.model.duty);
    var freeTradeZoneAgreements = joinDuty(this.model.free_trade_zone_agreements)
    var dutes_sng = joinDuty(this.model.duty_sng)
    return (
      <div className={classnames([classes.root], { [classes.noHeader]: !showTitle })} id={SCROLL_ROOT_ID}>

        <TopBar title={(!this.state.isMobile ? 'Справка для кода ' : '') + `${code}`} />

        {/* Срок действия */}
        {to_date !== null &&
          <CodeInfoDeadLine to_date={to_date} />
        }
        {/* Краткое описание товара */}
        {shortDescription &&
          <CodeInfoShortDescription code={code} shortDescription={shortDescription} />
        }
        {/* Дополнительный 4-х значный код */}
        {shortDescription && (code14.length > 0) &&
          <CodeInfoTNVED14 code14={code14} />
        }
        {/* Дерево перехода */}
        <CodeInfoTree model={this.model} />

        {/* Дополнительная единица измерения */}
        <CodeInfoAdditionalUnit unitName={this.model.unitName} />

        {/* Экспортная пошлина */}
        {
          direction !== DIRECTION_CUSTOMS.IMPORT &&
          <CodeInfoExportDuty exportDues={this.model.exportDues} />
        }
        {/* Экспортная пошлина в зависимости от страны назначения */}
        {
          direction !== DIRECTION_CUSTOMS.IMPORT && this.model.exportDuesAdjust.length !== 0 &&
          <CodeInfoExportDutyAdjust exportDues={this.model.exportDuesAdjust} />
        }
        {/* Импортная пошлина */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoImportDuty duties={duties} />
        }
        {/* Тарифные преференции */}
        {this.model.tariffPreference.length !== 0 && direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoTariffPreference tariffPreference={this.model.tariffPreference} />
        }
        {/* Импортная пошлина. Соглашения о зоне свободной торговли */}
        {freeTradeZoneAgreements.length !== 0 && direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoFreeTradeZoneAgreements freeTradeZoneAgreements={freeTradeZoneAgreements} />
        }
        {/* Импортная пошлина для стран СНГ */}
        {dutes_sng.length !== 0 && direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoImportDutySNG dutes_sng={dutes_sng} />
        }
        {/* Антидемпинговая пошлина */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoAdditionalDues additionalDues={this.model.additionalDues} />
        }
        {/* Акциз */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoImportAkcis exciseDues={this.model.exciseDues} />
        }
        {/* НДС */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoImportVat vat={this.model.vat} />
        }
        {/* Товар, подлежит маркировке акцизными (специальными) марками */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoExciseDutyMarks exciseDutyMarks={this.model.exciseDutyMarks} />
        }
        {/* Соответствие наименований подакцизных товаров кодам ТНВЭД ЕАЭС и кодам бюджетной классификации РФ */}
        {direction !== DIRECTION_CUSTOMS.EXPORT &&
          <CodeInfoBudgetClassification budgetClassification={this.model.budgetClassification} />
        }
        {/* Лицензии */}
        <CodeInfoLicence licence={this.model.licence} />

        {/* Квота */}
        <CodeInfoQuota quota={this.model.quota} />

        {/* Сертификаты */}
        {
          this.model.certification_types.map(function (cert) {
            return <CodeInfoCertification cert={cert} />
          })
        }
        {/* Товары двойного применения */}
        <CodeInfoDualUseGoods dualUseGoods={this.model.dualUseGoods} />

        {/* Объекты интеллектуальной собственности*/}
        {this.model.intellectual &&
          <CodeInfoIntellectual intellectual={this.model.intellectual} />
        }
        {/* Параллельный импорт*/}
        {direction !== DIRECTION_CUSTOMS.EXPORT && this.model.parallel_import &&
          <CodeInfoParallelImport parallel_import={this.model.parallel_import} />
        }
        {/* Особенности таможенного оформления */}
        <CodeInfoFeaturesOfCustomsClearance featuresOfCustomsClearance={this.model.featuresOfCustomsClearance} />

        {/* Требованиях к описанию отдельных категорий товаров в графе 31 */}
        <CodeInfoFillingInstruction fillingInstruction={this.model.fillingInstruction} />

        {/* Рекомендации */}
        <CodeInfoAdvice advice={this.model.advice} />

        {/* Классификационные решения */}
        <CodeInfoClassificationCertificate classificationCertificate={this.model.classificationCertificate} />

        {/* Сборник принятых предварительных решений таможенных органов государств – 
        членов Таможенного союза по классификации товаров' */}
        <CodeInfoPreliminaryClassificationCertificate preliminaryClassificationCertificate={this.model.preliminaryClassificationCertificate} />

        {/* Примечания к ТН ВЕД ЕАЭС */}
        <CodeInfoNotes model={this.model} onDate={onDate} />

        {/* Пояснения к ТН ВЭД ЕАЭС (в ред. от 19.02.2021 г.) */}
        <CodeInfoComments model={this.model} />

        {/* Разъяснений о классификации в соответствии с единой ТНВЭД ЕАЭС */}
        <CodeInfoClassificationComments model={this.model} onDate={onDate} />

        <BottomLine />
      </div>
    );
  }

}

function joinDuty(duties) {
  var result = []
  duties.forEach(item => {
    if (result.length === 0) {
      if (item.joined_origin_country === undefined) {
        if (item.origin_country_arial === undefined || item.origin_country_arial === null) {
          // если нет принадлежности к какой-либо группе стран
          item.joined_origin_country = item.origin_country !== '00' ? `${item.origin_country}` : "";
        }
        else {
          item.joined_origin_country = `${item.origin_country_arial.name}`;
        }
      }
      result.push(item);
      return;
    }

    var modified = false;
    for (let index = 0; index < result.length; index++) {
      if (result[index].order === item.order
        && result[index].order_date === item.order_date
        && result[index].customs_clearance_country === item.customs_clearance_country
        && result[index].hint === item.hint) {
        // если совпадает ставка, страна очистки и приказ, то позиция для отображения ставки
        // не добавляется
        if (item.origin_country !== null) {
          // страна происхождения/назначения не пустая
          if (result[index].joined_origin_country === undefined || result[index].joined_origin_country === null) {
            // текущее значение не установлено
            if (item.origin_country_arial === undefined || item.origin_country_arial === null) {
              // если нет принадлежности к какой-либо группе стран
              result[index].joined_origin_country = item.origin_country !== '00' ? `${item.origin_country}` : "";
            }
            else {
              result[index].joined_origin_country = `${item.origin_country_arial.name}`;
            }
          }
          else {
            // текущее значение установлено
            if (item.origin_country_arial === undefined || item.origin_country_arial === null) {
              // если нет принадлежности к какой-либо группе стран
              if (!result[index].joined_origin_country.includes(item.origin_country)) {
                result[index].joined_origin_country = `${result[index].joined_origin_country}${result[index].joined_origin_country ? ', ' : ''}${item.origin_country !== '00' ? item.origin_country : ''}`;
              }
            }
            else {
              if (!result[index].joined_origin_country.includes(item.origin_country_arial.name)) {
                result[index].joined_origin_country = `${result[index].joined_origin_country}${result[index].joined_origin_country ? ', ' : ''}${item.origin_country_arial.name}`;
              }
            }
          }
        }
        modified = true;
        break;
      }
    }

    if (modified === false) {
      if (item.joined_origin_country === undefined) {
        if (item.origin_country_arial === undefined || item.origin_country_arial === null) {
          // если нет принадлежности к какой-либо группе стран
          item.joined_origin_country = item.origin_country !== '00' ? item.origin_country : "";
        }
        else {
          item.joined_origin_country = item.origin_country_arial.name;
        }
      }
      result.push(item);
    }
  })
  return result;
}

export function formatDate(date) {
  if (date !== null) {
    date = moment(date, 'YYYY-MM-DD');
    return date.format('L');
  }
  return date;
}

export function formatOrder(order, date, orders_info = null) {

  if (orders_info !== null && orders_info.length > 0) {
    let results = []
    let number = 0;
    orders_info.forEach(item => {

      let text = item.doc_name;
      date = moment(item.date, 'YYYY-MM-DD');
      if (date.isValid()) text += ` от ${date.format('L')}`;
      results.push(<Button key={number.toString()} size="small" href={item.link} target="_blank" rel="noopener"> {text} </Button>);
      number++;
    })
    return results;
  }
  else {
    let result = '';
    if (order) result += order;
    if (date && result) {
      date = moment(date, 'YYYY-MM-DD');
      if (date.isValid()) result += ` от ${date.format('L')}`;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/components/CodeInfo.js